<template>
    <button @click.prevent.stop="$emit('act')" class="btn btn-filter btn-primary">
        {{ label }} &nbsp;<i :class="[icon, active ? 'fas':'far']"></i>
    </button>
</template>

<script>
export default {
    props: {
        label: String,
        icon: String,
    },
    data: () => ({
        active: false,
    }),
    computed: {

    },
};
</script>

